import { css } from 'linaria';

export const bathroomCollectionsHeaderTitle = css`
  && {
    margin-bottom: 12px;
  }
`;
